var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-empty-record"},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('p',[_vm._v("没有找到相关记录")])])}]

export { render, staticRenderFns }